import { useTranslation } from 'react-i18next'

const MARKETS = [
  { value: 'de', flag: '🇩🇪' },
  { value: 'co.uk', flag: '🇬🇧' },
  { value: 'fr', flag: '🇫🇷' },
  { value: 'es', flag: '🇪🇸' },
  { value: 'it', flag: '🇮🇹' },
  { value: 'nl', flag: '🇳🇱' },
]

interface MarketplaceFlagSelectProps {
  value: string
  onChange: (value: string) => void
}

export function MarketplaceFlagSelect({ value, onChange }: MarketplaceFlagSelectProps) {
  const { t } = useTranslation()
  return (
    <select
      className="campaign-creator-flag-select h-[46px] w-[72px] appearance-none rounded-[11px] border border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-xl text-center cursor-pointer outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20 transition-colors"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={t('campaignCreator.marketplaceLabel')}
    >
      {MARKETS.map((m) => (
        <option key={m.value} value={m.value}>{m.flag}</option>
      ))}
    </select>
  )
}
